import React from "react";
import ReactDOM from "react-dom";

// Libraries
import * as Sentry from "@sentry/browser";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";

// Service worker
import * as serviceWorker from "./serviceWorker";

// Components
import App from "./App";
import ErrorBoundary from "components/ErrorBoundary";

// Store
// import { StoreProvider } from './store'

// Styles
import "./index.css";

// Router
import { BrowserRouter } from "react-router-dom";
import { storage } from "services/config/storage";

// Check for Production environment
if (process.env.NODE_ENV && process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://dea5cdc88ece4036b404ca54770fe2e4@o404406.ingest.sentry.io/5268042",
  });

  LogRocket.init("gvun8n/unberry");
  setupLogRocketReact(LogRocket);

  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}

// reset local storage on startup
storage.destroy.all();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// });

// Activate the lifecycle execution
// GgcLifeCycleManager.activate();
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);
serviceWorker.unregister();
